module.exports = __webpack_public_path__ + "fonts/Estedad-Regular.361a23a6.woff2";